import type { MarkdownModeView } from '@atlassian/editor-plugin-markdown-mode';

import { expValEquals } from '@confluence/feature-experiments';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';

export type MarkdownViewMode = MarkdownModeView;

export const DEFAULT_MARKDOWN_VIEW_MODE: MarkdownViewMode = 'wysiwyg';

const isMarkdownViewMode = (value: unknown): value is MarkdownViewMode =>
	value === 'source' || value === 'wysiwyg' || value === 'preview';

export const readStoredMarkdownViewMode = (): MarkdownViewMode => {
	if (!expValEquals('cc-markdown-mode', 'isEnabled', true)) {
		return DEFAULT_MARKDOWN_VIEW_MODE;
	}
	const stored = confluenceLocalStorageInstance.getItem(keys.MARKDOWN_VIEW_MODE);
	return isMarkdownViewMode(stored) ? stored : DEFAULT_MARKDOWN_VIEW_MODE;
};

export const writeStoredMarkdownViewMode = (mode: MarkdownViewMode): void => {
	if (!expValEquals('cc-markdown-mode', 'isEnabled', true)) {
		return;
	}
	confluenceLocalStorageInstance.setItem(keys.MARKDOWN_VIEW_MODE, mode);
};
